import apiClient from "../utils/apiClient";

/**
 * Fetch user details.
 */
export const getUserDetails = async () => {
    try {
        const response = await apiClient.get("/user");
        return response.data.data;
    } catch (error) {
        console.error("Error fetching user details:", error);
        throw error;
    }
};

/**
 * Update user profile.
 * @param {Object} profileData - The updated profile details.
 */
export const updateUserProfile = async (profileData) => {
    try {
        const response = await apiClient.put("/user/profile", profileData);
        return response.data;
    } catch (error) {
        console.error("Error updating profile:", error);
        throw error;
    }
};

/**
 * Update user password.
 * @param {Object} passwordData - Contains current and new password.
 */
export const updateUserPassword = async (passwordData) => {
    try {
        const response = await apiClient.put("/user/password", passwordData);
        return response.data;
    } catch (error) {
        console.error("Error updating password:", error);
        throw error;
    }
};
